module.exports = __webpack_public_path__ + "img/guizhouHints_21.42187608.jpg";